var map = {
	"./01.png": "a4e7",
	"./02.png": "c675",
	"./03.png": "468f",
	"./04.png": "b8cc",
	"./05.png": "6f35",
	"./06.png": "be53",
	"./07.png": "9cd3",
	"./08.png": "3d9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6185";